export default {
  apiVersion: 2,
  development: {
    accessToken: '0c8c1a9e4db296f850d62ab253252f73',
    url: 'http://greifinn.dev.moya.is/_/moya/pilot/api',
  },
  production: {
    accessToken: '0c8c1a9e4db296f850d62ab253252f73',
    url: 'https://api.greifinn.is/_/moya/pilot/api',
  },
};
